import UI from './UI'
import Dialog from 'vant/es/dialog'
import 'vant/es/dialog/style/index'
import Toast from 'vant/es/toast'

let showUpdate = false

function updateVersion() {
  if (showUpdate) {
    return
  }
  showUpdate = true
  Dialog.alert({
    title: '提示',
    message: '网页连接超时',
    confirmButtonText: '刷新',
    confirmButtonColor: 'var(--btn-bg)'
  }).then(() => {
    location.reload()
  })
}

const install = function (Vue, router) {
  // Vue.use(alipush, router)
  Vue.use(UI)
  window.$toast = (data) => {
    Toast({
      position: 'top',
      message: data.message
    })
  }
  window.$alert = (data = {}, callback = () => {}) => {
    Dialog.alert({
      title: data.title,
      message: data.message,
      confirmButtonText: data.confirmText
    }).then(() => {
      callback && callback()
    })
  }
  window.$confirm = (data = {}, confirm = () => {}, cancel = () => {}) => {
    Dialog.confirm({
      title: data.title,
      message: data.message,
      confirmButtonText: data.confirmText,
      cancelButtonText: data.cancelButtonText
    })
      .then(() => {
        confirm && confirm()
      })
      .catch(() => {
        cancel && cancel()
      })
  }
  router.beforeEach((to, from, next) => {
    let query = to.query
    if (query.url && to.name != 'travelapproval') {
      sessionStorage.setItem('defaultUrl', query.url)
      if (query.id) {
        sessionStorage.setItem('url_id', query.id)
      } else {
        sessionStorage.removeItem('url_id')
      }
    }

    // 特殊登录地址重定向===个别集成企业
    if (to.path == '/login') {
      let loginUrl = $ZConfig.getVal('LOGIN_URL')
      if (loginUrl) {
        window.location.replace(loginUrl)
        return
      }

      // 没开启预约体验 直接跳转到账户登陆
      if ($ZConfig.getVal('showReg') != '1') {
        next({ path: '/login2' })
        return
      }
    }

    if (to.name == 'home') {
      let alpUrl = sessionStorage.getItem('alpUrl')
      let H5_HOME_URL = $ZConfig.getVal('H5_HOME_URL')
      // 国泰君安H5_HOME_URL = /common/gtjaMiddlePage
      window.$tool &&
        window.$tool.logger('home_url', {
          type: 'H5_HOME_URL',
          data: {
            url: H5_HOME_URL,
            alpUrl: alpUrl
          }
        })

      if (H5_HOME_URL) {
        if (H5_HOME_URL.startsWith('http')) {
          location.replace(H5_HOME_URL)
        } else {
          location.replace(location.origin + H5_HOME_URL)
        }
        return
      } else if (alpUrl) {
        location.replace(location.origin + alpUrl)
        return
      }
    }
    next()
  })

  // 版本更新处理
  router.onError((error) => {
    // console.log(error, error.message)
    if (error.name == 'ChunkLoadError') {
      updateVersion()
    }
  })
}

const mount = function () {}

const unmount = function () {}

export default {
  install,
  mount,
  unmount
}
